import React, {useEffect, useContext} from 'react';
import classNames from 'classnames';
import timetablePng from '../images/Timetable.png';
import axios from 'axios';
import { DataContext } from '../context/DataContext';
import { toTitleCase } from '../util/titleCase';
import { useHistory } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';

// const navItems = [
//   {
//     label: 'Agricultural First CA',
//     condition: 'ongoing',
//   },
//   {
//     label: 'Basic Technology Exam',
//     condition: 'ongoing',
//   },
//   {
//     label: 'Business Studies Exam',
//     condition: 'retake',
//   },
//   {
//     label: 'Basic Science and Technology Exam',
//     condition: 'retake',
//   },
//   {
//     label: 'Mathematics CA',
//     condition: 'completed',
//   },
//   {
//     label: 'Basic Science and Technology First CA ',
//     condition: 'completed',
//   },
//   {
//     label: 'Computer Studies First CA',
//     condition: 'completed',
//   },
//   {
//     label: 'English Language First CA',
//     condition: 'completed',
//   },
//   {
//     label: 'Computer Studies Second CA',
//     condition: 'completed',
//   },
//   {
//     label: 'Basic Technology Exam',
//     condition: 'completed',
//   }
// ];

const CbtSidebar = () => {
  const dataContext = useContext(DataContext);
  const history = useHistory();

  const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
  const admissionnumber = studentInfo[0].admissionnumber;
  const schoolDomain = localStorage.getItem('schoolDomain');

  const NavItem = ({ navItem }) => {
    
      const retake = navItem.IsExamRetake;
      const newExam = navItem.IsExamNew;
      // const completed = navItem.IsExamCompleted;
      const ongoing = navItem.IsExamOngoing;
    const classes = classNames({
      'leading-none text-xs leading-4 flex font-semibold w-full border-b border-gray-600 cursor-pointer': true,
      // 'text-gray-400 opacity-50 cursor-not-allowed': completed, 
      'text-gray-200': newExam
    });
      const greenCircle = classNames({
          'w-2 h-2 border-0 bg-white rounded-full' : true,
          'border-0 bg-green-100' : ongoing
      })
    return (
      <div onClick={() => handleClick(navItem)} className={classes}>
        <div className="flex items-center w-full py-3 flex-shrink-0 z-0">
          <div className="mr-0">
            <img src={timetablePng} alt='icon' /> 
          </div>
          <span className="mr-4 truncate">
            {toTitleCase(navItem.subjectname)} {" "} {toTitleCase(navItem.division_name)}
          </span>
          <span className={greenCircle}></span>
        </div>
      </div>
    );
  };
  
  const NavItemContainer = ({ children }) => (
    <div>{children}</div>
  );

  useEffect(() => {
    const cbtDataBody = {
      // SchoolUrl: 'demo.edves.net',
      SchoolUrl : schoolDomain,
      admissionnumber
    }
    const getCbtExams = async () => {
      try {
          const { data } = await axios.post(`student/getcbtExams`, cbtDataBody);
          console.log(data)
          dataContext.setCbtData(data.data);
          const isCompleted = data.data.map(exam => exam.IsExamCompleted && exam);
          // dataContext.setCbtData(isCompleted)
      } catch (error) {
          console.log('Fetch exams error', error)
      }
    };
    getCbtExams();
  }, []);

  const handleClick = (item) => {
    dataContext.setClickedCbtItem(item);
    localStorage.setItem('clickedCbtItem', JSON.stringify(item));
    localStorage.removeItem('ongoingAnsweredQsts');
    history.push('test')
  }

  return (
    <Scrollbars autoHide style={{ height: 550, marginBottom: 24 }}>
      <section className="w-full h-full mt-4 z-0">
        <div className="-mt-1 mx-0">
          {dataContext.cbtData && dataContext.cbtData.length > 0 && dataContext.cbtData
            .filter(exam => !exam.IsExamCompleted && exam.online === "1")
            .map((navItem, index) => {
            // console.log(navItem)
            return (
              <div key={index}>
                <NavItemContainer key={navItem.idx}>
                  <NavItem navItem={navItem} />
                </NavItemContainer>
              </div>
            )
          })}
        </div>
      </section>
    </Scrollbars >
  );
};

export default CbtSidebar;
